import { render, staticRenderFns } from "./banner-detail.vue?vue&type=template&id=4da864d2"
import script from "./banner-detail.vue?vue&type=script&lang=js"
export * from "./banner-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports